import React from 'react';
import ActionListDivider from './components/actionListDivider';
import ActionListItem from './components/actionListItem';
import { ActionListProvider } from './context';
import { ActionListProps } from './indes.types';

const ActionList = ({
  children,
  className,
  testID,
  ...props
}: ActionListProps) => {
  const componentTestId = testID ? `${testID}-action-list` : 'action-list';

  return (
    <ActionListProvider value={{ testID }}>
      <div
        data-slot="action-list"
        className={className}
        data-testid={componentTestId}
        role="listbox"
        {...props}
      >
        {children}
      </div>
    </ActionListProvider>
  );
};

ActionList.Item = ActionListItem;
ActionList.Divider = ActionListDivider;

export default ActionList;